import axios from "@/helpers/axios";
export default {
  getSingleData({ model, id }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/${model}/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  postData({ model, data }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/${model}`, data)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
};
